module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-334de48347065b8bf9ba6ba289580411.png";